module.exports = __webpack_public_path__ + "img/formula.08b71d0c.png";